import { AuthContext } from "@/auth/authcontext";
import { useVerifyOtp, type AuthError } from "@/hooks/api/use-auth";
import { FormEvent, useContext, useState } from "react";
import { useNavigate } from "react-router";
import { toast } from "sonner";

export default function OtpPage() {
  const { setUserDetails } = useContext(AuthContext);
  const [otp, setOtp] = useState("");
  const tempOtpToken = localStorage.getItem("tempOtpToken") || "";

  const verifyOtp = useVerifyOtp();
  const navigate = useNavigate();

  function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    verifyOtp.mutate(
      { otp, tempOtpToken },
      {
        onSuccess: (data) => {
          setUserDetails(data);
          return navigate("/");
        },
        onError: (error: AuthError) => {
          if (error.status === "token_expired") {
            // token expired, redirect to login
            return navigate("/login/");
          }
          toast.error(error.message || "Failed to verify OTP");
        },
      }
    );
  }

  return (
    <div className="flex justify-center min-h-screen my-8 ">
      <div className="w-96 px-4 py-4">
        <div>
          <h2 className="mt-6 text-center text-2xl font-bold text-gray-900 dark:text-gray-100">
            Sign In
          </h2>
          <form className="max-w-sm mx-auto" onSubmit={onSubmit}>
            <div className="form-control w-full">
              <label className="label font-bold" htmlFor="email">
                Enter the one-time-code generated by your authenticator
                application
              </label>
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                name="otp"
                id="otp"
                className="input input-bordered w-full"
                placeholder="012345"
                required
                onChange={(e) => setOtp(e.target.value)}
                value={otp}
              />
              {verifyOtp.error && (
                <p className="text-xs text-red-500 mt-2">
                  {verifyOtp.error.message}
                </p>
              )}
            </div>
            <div className="mt-2">
              <button
                type="submit"
                className="btn btn-primary btn-block"
                disabled={verifyOtp.isPending}
              >
                {verifyOtp.isPending ? "Verifying..." : "Sign In"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
